import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';

const client = generateClient();

const listDailyActivitiesGql = /* GraphQL */ `
  query ListDailyActivities($filter: ModelDailyActivityFilterInput, $limit: Int) {
    listDailyActivities(filter: $filter, limit: $limit) {
      items { id owner date kind count createdAt updatedAt }
      nextToken
    }
  }
`;

const createDailyActivityGql = /* GraphQL */ `
  mutation CreateDailyActivity($input: CreateDailyActivityInput!) {
    createDailyActivity(input: $input) {
      id owner date kind count
    }
  }
`;

const updateDailyActivityGql = /* GraphQL */ `
  mutation UpdateDailyActivity($input: UpdateDailyActivityInput!) {
    updateDailyActivity(input: $input) {
      id owner date kind count
    }
  }
`;

const isoDate = (d = new Date()) => d.toISOString().slice(0, 10);

export async function recordDailyActivity(kind = 'generic', increment = 1) {
  const user = await getCurrentUser();
  const owner = user?.username;
  if (!owner) throw new Error('Not authenticated');

  const today = isoDate();
  // Find existing record for today
  const { data } = await client.graphql({
    query: listDailyActivitiesGql,
    variables: {
      filter: {
        owner: { eq: owner },
        date: { eq: today }
      },
      limit: 1
    },
    authMode: 'userPool'
  });

  const existing = data?.listDailyActivities?.items?.[0];

  if (existing) {
    return client.graphql({
      query: updateDailyActivityGql,
      variables: {
        input: {
          id: existing.id,
          count: (existing.count || 0) + increment,
          kind // optional: last kind that touched it
        }
      },
      authMode: 'userPool'
    });
  }

  return client.graphql({
    query: createDailyActivityGql,
    variables: {
      input: {
        owner,
        date: today,
        kind,
        count: increment
      }
    },
    authMode: 'userPool'
  });
}

export async function fetchRecentDailyActivities(days = 365) {
  const user = await getCurrentUser();
  const owner = user?.username;
  if (!owner) throw new Error('Not authenticated');

  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - (days - 1));

  // We’ll fetch via filter by owner and a between range on date
  const { data } = await client.graphql({
    query: listDailyActivitiesGql,
    variables: {
      filter: {
        owner: { eq: owner },
        date: { between: [isoDate(start), isoDate(end)] }
      },
      limit: 1000
    },
    authMode: 'userPool'
  });

  return (data?.listDailyActivities?.items || []).map(i => ({
    date: i.date,
    count: i.count || 0
  }));
}
